<template>
    <div v-if="item">
        <div class="blog-card"  @click="showDetail(item.id)">
            <section class="img">
                <img class="img-card" :src="item.post_image_url" alt="">
            </section>
            <section class="content">
                <div class="title-card">{{ item.id }}{{ item.post_title }}</div>
                <div class="description-crad">
                    <p>{{ removeHTMLTags(item.post_content) }}</p>
                </div>
                <div class="detail-crad">
                    <div class="created-by">By BeNeat</div>
                    <div><i class="time"></i>{{ item.updated_at | prettyOnlyDateBE}}</div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
export default {
  name: 'cradBlog',
  props: ['item'],
  methods: {
    removeHTMLTags (htmlString) {
      // Create a new DOMParser instance
      const parser = new DOMParser()
      // Parse the HTML string into a DOM document
      const doc = parser.parseFromString(htmlString, 'text/html')
      // Extract the text content from the parsed document
      const textContent = doc.body.textContent || ''
      return textContent.trim() // Trim any leading or trailing whitespace
    },
    showDetail (blogId) {
      console.log('blogId', blogId)
      this.$router.push(`/blog/${blogId}`)
    }
  }
}
</script>
<style scoped lang="scss">
.blog-list {
    margin-top: 24px;
    column-gap: 24px;
    row-gap: 32px;
    display: grid;
    grid-template-columns: auto auto auto;
}
.blog-card {
    width: 100%;
    height: auto;
}
.blog-card:hover {
    width: 100%;
    height: auto;
    .title-card{
        font-size: 18px;
        font-weight: 600;
        color: #00B4CD;
    }
    .img-card {
        width: 100%;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
}
.description-crad p{
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 14px;
    font-weight: 400;
    color: #7F7F7F;
    margin-top: 14px;
}
.title-card {
    font-size: 18px !important;
    font-weight: 600;
}
.detail-crad {
    display: flex;
    column-gap: 40px;
    align-items: center;
    color: #7F7F7F;
}
.time {
    background: url('/static/img/Vector.png');
    background-size: 20px 20px;
    position: absolute;
    width: 20px;
    height: 20px;
    margin-left: -27px;
    margin-top: 2px;
}
.detail-crad .created-by {
    font-size: 14px;
    font-weight: 400;
    color: #4D4D4D;
}
.img-card {
    width: 100%;
}
.content {
    margin-top: 24px;
}
@media (max-width: 425px) {
  .blog-list {
    grid-template-columns: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/blogs/components/CardBlog.vue